<div class="row">
    <div class="col-12">        
        <div class="table-responsive">
            <table class="table table-bordered">                      
                <thead>
                    <tr>
                        <th class="col-options"></th>
                        <th class="col-marca">Marca</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities; let i = index">
                        <td class="col-options">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-marca">
                            <select class="form-control" name="marca_{{i}}" id="marca_{{i}}" 
                                [ngModel]="entity.idItemMarca || ''" (ngModelChange)="onChangeMarca(entity, $event ? $event : null)"
                                #marca="ngModel">
                                <option value="">Selecione a marca...</option>
                                <option *ngFor="let marca of marcas" [ngValue]="marca.id">{{marca.nome}}</option>
                            </select>                                
                        </td>                                                               
                    </tr>          
                    <tr *ngIf="entities.length === 0" class="no-record">
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                        </td>
                    </tr>
                </tbody>
                <tfoot class="table-footer">
                    <tr>
                        <td colspan="2">
                            <button type="button" class="btn btn-primary mr-2" (click)="insert()">
                                <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Marca
                            </button> 
                            <button type="button" class="btn btn-light" (click)="adicionarTodasMarcas()">
                                <i class="fas fa-bolt" aria-hidden="true"></i> Adicionar Todas Marcas
                            </button>                                               
                        </td>                               
                    </tr>
                </tfoot>        
            </table>
        </div>
    </div>
</div>